import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    this.handleOpenEvent = this.open.bind(this);
    this.handleCloseEvent = this.close.bind(this);

    window.addEventListener("alert-modal:open", this.handleOpenEvent);
    window.addEventListener("alert-modal:close", this.handleCloseEvent);
  }

  disconnect() {
    window.removeEventListener("alert-modal:open", this.handleOpenEvent);
    window.removeEventListener("alert-modal:close", this.handleCloseEvent);
  }

  open() {
    this.element.showModal();
  }

  close() {
    this.element.close();
  }
}
